import MAIN from "@/locales/MAIN.ru.json";

import PHP_CONFIG from "@/locales/PHP_CONFIG.ru.json";

export default {
  ...MAIN,
  ...PHP_CONFIG
};
